import { locale } from './locale';

export const environment = {
    production: true,
    locale: locale,
    recaptchaApiKey: '6LdIiU4rAAAAAN2qbSlje7UcdUB4aw6drPfyClh3',
    gaApiKey: 'G-CS2NYTBPDK',
    gtagApiKey: 'GTM-NFPK7DCR'
};
